import { useEffect, useRef } from "react";

export default function SoldOutBanner() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    // Clone the content for seamless loop
    const content = scrollContainer.querySelector('.scroll-content');
    if (content) {
      const clone = content.cloneNode(true);
      scrollContainer.appendChild(clone);
    }
  }, []);

  const bannerText = "We are SOLD OUT! Thank you for your generosity in supporting the B-ISN Inaugural Charity Golf Classic.";

  return (
    <div 
      className="w-full bg-[#3A5F40] py-3 md:py-4 overflow-hidden"
      data-testid="sold-out-banner"
    >
      <div 
        ref={scrollRef}
        className="flex whitespace-nowrap animate-marquee"
      >
        <div className="scroll-content flex items-center">
          {[...Array(4)].map((_, i) => (
            <span 
              key={i} 
              className="text-white font-bold text-base md:text-lg px-8 md:px-16"
              style={{ fontFamily: 'inherit' }}
            >
              {bannerText}
            </span>
          ))}
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
    </div>
  );
}
